/**
 * Created by neo on 28.05.17.
 */

import {observable} from 'mobx';

export default class DateRange {
  @observable startDate: string;
  @observable endDate: string;

  constructor(json?: string) {
    if(json) {
      this.startDate = json.startDate;
      this.endDate = json.endDate;
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/DateRange.js